module.exports = __webpack_public_path__ + "static/media/22.8bbf3f27.mp3";